export default __webpack_public_path__ + "static/media/coffee0.43c9b216.jpeg";